<template>
    <div>
        <div class="row mb-8">
            <div class="col-6 d-flex justify-content-start">
                <v-card-title>
                    {{ $t('Delivery.DeliveryOrders.ClientOrders') }}
                </v-card-title>
            </div>
            <div class="col-6 d-flex justify-content-end">

            </div>
        </div>
        <v-card elevation="0">
            <DeliveryClientOrdersList :deliveryOrderId="deliveryOrderId" />
        </v-card>
    </div>
</template>
<script>
import { isClient } from "@/api/index";
import DeliveryClientOrdersList from "./DeliveryClientOrdersList.vue";
export default {
    components: {
        DeliveryClientOrdersList,
    },
    data() {
        return {
            showFilterDialog: false,
            deliveryOrderId: this.$route.params.id,
        }
    },
    mounted() {
        document.title = window.VUE_APP_NAME + ' - ' + this.$t('Document.Title.purchasesOrder');
    },
    methods: {
        openFilterDialog(newValue) {
            this.showFilterDialog = newValue;
        },
        closeFilterDialog() {
            this.showFilterDialog = false;
        },
        navigateToNewBrand() {
            this.$router.push({ path: '/NewDelivery' });
        },
        isClient() {
            return isClient()
        }
    }
};

</script>
